<template>
    <div>
        <div v-for="item in merged.get_line_items(order)" :key="item.id">
            <v-row no-gutters class="pa-3" v-if="item.fulfillable_quantity">
                <v-col v-if="show('images')" cols="2" class="py-0 pr-2">
                <v-responsive max-height="100%" max-width="100%" v-if="images[`${item.product_id}|${item.variant_id}`]">
                        <v-img
                            :src="images[`${item.product_id}|${item.variant_id}`].url"
                            aspect-ratio="1"
                            class="grey lighten-2"
                            :max-height="display_settings.expanded.products.subsections.images.options.size.value"
                            :max-width="display_settings.expanded.products.subsections.images.options.size.value"
                            @error="reload_image(item.product_id, item.variant_id)"
                            >
                        </v-img>
                    </v-responsive>
                </v-col>
                <v-col cols="10" class="caption">
                    <v-row no-gutters>
                        <v-col cols="7">
                            <span v-if="show('quantity')" class="font-weight-bold">{{ item.fulfillable_quantity }}</span> <span v-if="show('quantity') && show('title')">x </span>
                            <v-tooltip top v-if="show('title')">
                                <template v-slot:activator="{ on }">
                                    <span v-on="on">
                                        {{ item.name }}
                                    </span>
                                </template>
                                <span>{{ item.name }}</span>
                            </v-tooltip>
                        </v-col>
                        <v-col cols="2">
                            <div v-if="show('unit_price')" class="float-right">${{ item.price | formatNumber(2)}}</div>
                        </v-col>
                        <v-col cols="3">
                            <div v-if="show('total_price')" class="float-right">${{ item.price * item.fulfillable_quantity | formatNumber(2)}}</div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters v-if="item.goods_description">
                        <v-col>
                            <span class="font-weight-bold">Goods Description:</span> {{ item.goods_description }}
                        </v-col>
                    </v-row>
                    <v-row no-gutters v-if="show('sku') || show('properties')">
                        <v-col>
                            <div v-if="show('sku')" class="caption grey--text">{{ item.sku }}</div>
                            <div v-if="show('properties') && item.properties">
                                <v-row v-for="(p, index) of item.properties" v-bind:key="index" no-gutters>
                                    <v-col class="caption font-weight-bold">{{ p.name }}:</v-col>
                                    <v-col class="caption">{{ p.value }}</v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters v-if="!is_domestic && (show('hs_code') || show('country_of_origin'))">
                        <v-col>
                            <div class="caption grey--text" v-if="show('hs_code')">HS Code: {{ item.hs_code }} <span v-if="!item.hs_code" class="red--text" @click="edit = true">Not specified</span></div>
                        </v-col>
                        <v-col>
                            <div class="caption grey--text" v-if="show('country_of_origin')">Country of Origin: {{ item.country_of_origin }} <span v-if="!item.country_of_origin" class="red--text" @click="edit = true">Not specified</span></div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
        <InternationalActions :order="order"/>
    </div>
</template>

<script>
import orderTools from "@/V2/helpers/orderTools";
import mergeTools from "@/V2/helpers/mergeTools";
import InternationalActions from "@/V2/components/Orders/InternationalActions.vue"
import { mapGetters } from 'vuex'

export default {
    name: 'Items',
    props: ['order'],
    components: {
        InternationalActions
    },
    data: function () {
        return {
            merged: mergeTools,
            orderTools: orderTools,
            edit: false
        }
    },
    methods: {
        show(subsection) {
            return this.display_settings.expanded.products.subsections[subsection].status
        },
        reload_image(product_id, variant_id) {
            this.$store.dispatch('Images/get_image', { image: `${product_id}|${variant_id}`, update: true })
        },
    },
	computed : {
        ...mapGetters({
            display_settings: 'Settings/display_settings',
            images: 'Images/images',
        }),
        is_domestic(){
            return orderTools.is_domestic(this.order)
        }
    }
}
</script>

